import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import App from "./containers/App/App";
import { store } from "./redux/store/index";

import "./assets/styles/globals.css";

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
      {/* RHT Component */}
      <Toaster
        toastOptions={{
          position: "top-left",
          style: { background: "#333", color: "#fff" },
        }}
      />
    </Provider>
  </React.StrictMode>
);
